
import { Component, Prop } from 'vue-property-decorator'
import { AppInput } from '@/components'
import { appAccountEntity } from '@/models/models'
import CommonForm from '@/mixins/CommonForm'

@Component({
    components: {
        AppInput,
    },
})
export default class DetailDDAppleAccountForm extends CommonForm {
    @Prop() public value?: AppAccountEntity

    get account(): AppAccountEntity {
        return this.value ? this.value : appAccountEntity
    }
}
